/**
 * File Name          : MCU.model.ts
 * Author             : Jared Laine Dyreson
 * Version            : 0.0.0
 * Date               : 2026-03-18
 * Description        : Short Description (manual edit required)
 * 
 * Copyright (C) Innovative Design Labs, Inc. - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * This file is subject to the terms and conditions defined in
 * file 'IDL_BACKGROUNDTECH_LICENSE.txt', which is part of this source code package.
 */

export interface MCU_IMAGE_STATE {
    active: boolean;
    bootable: boolean;
    confirmed: boolean;
    hash: ArrayBuffer;
    pending: boolean;
    permanent: boolean;
    slot: number;
    version: string;

    
}

export namespace MCU_IMAGE_STATE {
    export function fromBytes(bytes: Uint8Array): MCU_IMAGE_STATE {
        const dv = new DataView(bytes.buffer, 0);
        const active = (bytes[0]) !== 0;
        const bootable = (bytes[1] ) !== 0;
        const confirmed = (bytes[2] ) !== 0;
        const hash = bytes.slice(3, 35).buffer;
        const pending = (bytes[35] ) !== 0;
        const permanent = (bytes[36] ) !== 0;
        const slot = bytes[37];

        const version_major = bytes[38];
        const version_minor = bytes[39];
        const version_patch = dv.getUint16(40, true); 
        const build_number = dv.getUint32(42, true);
        
        return {
            active,
            bootable,
            confirmed,
            hash,
            pending,
            permanent,
            slot,
            version: `${version_major}.${version_minor}.${version_patch}+${build_number}`
        }
    }

    export const BYTE_LENGTH = 46;
}